var render = function render(){var _vm=this,_c=_vm._self._c;return _c('qb-panel',{staticClass:"qb-margin-top",attrs:{"title":"CARRINHO"}},[_c('qb-table')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }